// Copied structure from chrome extension
export const VERITY_ATTRIBUTES = {
	CLASSNAME: {
		CHECKBOX_WRAPPER_DIV: "yuja-verity-settings-checkbox-wrapper",
		INSTRUCTOR_ERROR_IFRAME_WRAPPER: "verity-no-extension-error-iframe-wrapper",
		BADGE_ROOT: "verity-badge-root",
		BUTTON: "verity-injected-button",
		STUDENT_ERROR_MODAL: "verity-modal-iframe",
		SHADOW_DOM_ROOT: "shadow-dom-render-root",
	},
	ATTRIBUTE: {
		PROCESS: "data-verity-processing",
	},
	ID: {
		FONT_STYLE: "yuja-verity-font-style",
	},
	KEY: {
		CHECKBOX_ERROR: "verity-error-shadow",
		BADGE: "verity-badge-shadow",
	},
	MESSAGE: {
		TYPE: {
			VERITY_ASSESSMENT_LISTENERS_ASK_IF_LOADED: "verityAssessmentListenersAskIfLoaded",
			VERITY_ASSESSMENT_LISTENERS_LOADED: "verityAssessmentListenersLoaded",
			START_PRE_CHECK: "startPreAssessmentCheck",
			PRE_CHECK_FINISHED: "preAssessmentCheckFinished",
			STOP_PROCTORING: "stopProctoring",
			STOP_PROCTORING_RESPONSE: "stopProctoringResponse",
			GET_PROCTORING_SESSION_ID: "getProctoringSessionId",
			GET_PROCTORING_SESSION_ID_RESPONSE: "proctoringSessionIdResponse",
			VERITY_ASSESSMENT_ERROR: "verityAssessmentError",
		},
	},
};
